// extracted by mini-css-extract-plugin
var _1 = "xXIfi__entry";
var _2 = "xXIfi__features";
export { _1 as "entry", _2 as "features" }
